<template>
  <v-menu v-model="mostrar" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :content="activeFiltersCount"
        :value="activeFiltersCount"
        color="secondary"
        overlap>
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-badge>
    </template>
    <v-card
      width="450px">
      <v-card-title>
        Filtros
        <v-spacer></v-spacer>
        <v-btn
          v-if="activeFiltersCount"
          text
          small
          color="secondary"
          @click="limpiarFiltros">
          Limpiar
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <custom-select
            v-model="filtros.tipos"
            label="Tipo"
            item-value="id"
            item-text="textoTipo"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeLicitacion">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.normatividad"
            label="Normatividad"
            item-value="id"
            item-text="textoNormatividad"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeNormatividad">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.caracter"
            label="Carácter"
            item-value="id"
            item-text="textoCaracter"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="tiposDeCaracter">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
          <custom-select
            v-model="filtros.estatus"
            label="Estatus"
            multiple
            clearable
            chips
            small-chips
            deletable-chips
            :items="estatusDeLicitacion">
          </custom-select>
          <v-col
            cols="12"
            class="my-1">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="secondary"
          @click="mostrar = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
// import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'FiltrosLicitaciones',
  components: {
    // CustomAutoComplete,
    CustomSelect,
  },
  props: {
    licitaciones: {
      type: Array,
      required: false,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
      ],
      tiposCaracter: [
        { id: 1, texto: 'NACIONAL' },
      ],
      tiposNormatividad: [
        { id: 1, texto: 'FEDERAL' },
        { id: 2, texto: 'ESTATAL' },
      ],
    };
  },
  methods: {
    limpiarFiltros() {
      this.filtros.tipos = [];
      this.filtros.normatividad = [];
      this.filtros.caracter = [];
      this.filtros.estatus = [];
    },
    getTextoTipo(tipo) {
      const encontrado = this.tiposLicitacion.find((tipoLicitacion) => tipo === tipoLicitacion.id);
      return encontrado || { id: tipo, texto: 'Desconocido' };
    },
    getTextoNormatividad(normatividad) {
      const encontrado = this.tiposNormatividad
        .find((tipoNormatividad) => normatividad === tipoNormatividad.id);
      return encontrado || { id: normatividad, texto: 'Desconocido' };
    },
    getTextoCaracter(caracter) {
      const encontrado = this.tiposCaracter
        .find((tipoCaracter) => caracter === tipoCaracter.id);
      return encontrado || { id: caracter, texto: 'Desconocido' };
    },
  },
  computed: {
    activeFiltersCount() {
      return [
        this.filtros.tipos.length,
        this.filtros.normatividad.length,
        this.filtros.caracter.length,
        this.filtros.estatus.length,
      ].reduce((total, count) => total + count, 0);
    },
    tiposDeLicitacion() {
      if (!this.licitaciones || this.licitaciones.length === 0) return [];
      const tiposDeLicitacion = this.licitaciones.map((licitacion) => ({
        id: licitacion.tipo,
        textoTipo: this.getTextoTipo(licitacion.tipo).texto,
      }));
      if (tiposDeLicitacion.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeLicitacion, 'id')
        .sort((a, b) => (`${a.textoTipo}`).localeCompare(b.textoTipo));
    },
    tiposDeNormatividad() {
      if (!this.licitaciones || this.licitaciones.length === 0) return [];
      const tiposDeNormatividad = this.licitaciones.map((licitacion) => ({
        id: licitacion.normatividad,
        textoNormatividad: this.getTextoNormatividad(licitacion.normatividad).texto,
      }));
      if (tiposDeNormatividad.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeNormatividad, 'id')
        .sort((a, b) => (`${a.textoNormatividad}`).localeCompare(b.textoNormatividad));
    },
    tiposDeCaracter() {
      if (!this.licitaciones || this.licitaciones.length === 0) return [];
      const tiposDeCaracter = this.licitaciones.map((licitacion) => ({
        id: licitacion.caracter,
        textoCaracter: this.getTextoCaracter(licitacion.caracter).texto,
      }));
      if (tiposDeCaracter.length <= 0) return [];
      return this.$removerDumplicadosArrayObj(tiposDeCaracter, 'id')
        .sort((a, b) => (`${a.textoCaracter}`).localeCompare(b.textoCaracter));
    },
    estatusDeLicitacion() {
      if (!this.licitaciones || this.licitaciones.length === 0) return [];
      const estatusDeLicitacion = this.licitaciones.map((licitacion) => licitacion.estatus);
      if (estatusDeLicitacion.length <= 0) return [];
      return [...new Set(estatusDeLicitacion)]
        .sort((a, b) => (`${a}`).localeCompare(b));
    },
  },
};
</script>

<style lang="scss">
</style>
